import { useNavigation } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";
import { sanitizeForFirestore } from "../../../modules/core/sanitizeForFirestore";
import { FullScreenLoading } from "../../../ui/Loading";
import { BusinessScheduleItemForm } from "../../schedule/BusinessScheduleItemForm";
import { BusinessAdminView } from "../BusinessAdminView";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "CustomerAdminTemplateScheduleItemEdit"
>;

export const BusinessAdminTemplateScheduleItemEditScreen = observer(
  ({ route }: Props) => {
    const customerUid = route.params.customerUid;
    const templateUid = route.params.templateUid;
    const scheduleItemUid = route.params.scheduleItemUid;
    const navigation = useNavigation();
    const { businessTemplatesApi } = useApi();
    const { businessTemplatesStore } = useStores();

    const template = businessTemplatesStore.byId.get(templateUid);

    const scheduleItemData = template?.data.schedule.find(
      (s) => s.uid === scheduleItemUid,
    );

    React.useEffect(() => {
      return businessTemplatesApi.watchItem(templateUid);
    }, [templateUid, businessTemplatesApi]);

    if (!template || !scheduleItemData) {
      return <FullScreenLoading />;
    }

    return (
      <BusinessAdminView customerUid={customerUid}>
        <BusinessScheduleItemForm
          data={scheduleItemData}
          businessPlanStartingDate={null}
          onSave={async (data) => {
            if (
              (data.date === null && data.offsetInDays === null) ||
              !data.title
            ) {
              return;
            }

            await template.updateBusinessTemplateScheduleItem({
              ...scheduleItemData,
              date: data.date ?? null,
              offsetInDays: data.offsetInDays ?? null,
              emoji: data.emoji ?? null,
              title: data.title,
              description: sanitizeForFirestore(data.description ?? null),
              schedule: data.schedule ?? null,
            });

            navigation.goBack();
          }}
        />
      </BusinessAdminView>
    );
  },
);
